('nav.main__navigation>ul').dropDown(el => {
    el.classList.add('--active');
}, el => {
    el.classList.remove('--active');
}, 200);
